module.exports = __webpack_public_path__ + "img/round-app.5eb4559f.svg";